import { ViewContainer } from '@fortem-monorepo/react-spa'

import { Page } from '@/components/Page'
import { FLOW } from '@/constants/links'
import { LevelsTable } from '@/pages/flow/rfq/components/LevelsTable'
import { MarketDataTable } from '@/pages/flow/rfq/components/MarketDataTable'

export interface FlowRFQPageProps {}

export const FlowRFQPage: React.FC<FlowRFQPageProps> = ({}) => {
  return (
    <Page metadata={{ title: 'RFQ' }} permissions={FLOW.RFQ.permissions}>
      <ViewContainer className={'flex flex-col gap-4'}>
        <LevelsTable />
        <MarketDataTable />
      </ViewContainer>
    </Page>
  )
}
